// Plain string map (not a React component). These toast strings are
// brand-fixed to Cofactor; keep "Install Cofactor in Teams" consistent with
// the label in TeamsSettingsSection.
const INSTALL_REASON_MESSAGES: Record<string, string> = {
  tenant_already_claimed:
    'That Microsoft tenant is already bound to a different Cofactor organization. Contact support if you believe this is in error.',
  invalid_callback:
    'Microsoft returned an invalid response. Try the install button again, or use the manual tenant id paste.',
  expired: 'The install link expired. Click "Install Cofactor in Teams" again.',
  invalid: 'The install state was invalid. Click "Install Cofactor in Teams" again.',
  wrong_browser:
    'That install was started in a different browser. Click "Install Cofactor in Teams" again in this browser.',
  access_denied: 'You declined the consent prompt. Click "Install Cofactor in Teams" to retry.',
  token_exchange_failed:
    'Microsoft rejected our token exchange. Try again, or contact support if it keeps happening.',
  missing_tenant:
    'Microsoft didn’t return a tenant id. Try the install button again; if it keeps failing, contact support.',
  misconfigured:
    'The Teams integration is not configured in this environment yet. Contact support.',
  catalog_publish_failed:
    'Your tenant id was bound, but publishing Cofactor to your tenant catalog failed. Use the Step 2 manual upload, or click Install again.',
};

export function getTeamsInstallErrorToast(reason: string): {
  message: string;
  reportError: boolean;
} {
  const message = INSTALL_REASON_MESSAGES[reason];
  if (message) {
    return { message, reportError: false };
  }

  return {
    message:
      'Microsoft admin consent failed. Try again, or use the advanced manual paste below.',
    reportError: true,
  };
}
